// extracted by mini-css-extract-plugin
export default {"header":"header_header__TRXcv","isWhite":"header_isWhite__0VUrD"};